import React from 'react';
import Icon from "antd/lib/icon";

const WhatsNew = () => {
  const iconStyle = { fontSize: "33pt", textAlign: "center" };
  const textStyle = { fontSize: "8pt", marginTop: "5px" };
  // const column = { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" };

  return (
    // <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px", marginBottom: "10px" }}>
    //   <div style={column}>
    //     <Icon type="customer-service" style={iconStyle} />
    //     <div style={textStyle}>Built-in P2P Network</div>
    //   </div>
    //   <div style={column}>
    //     <Icon type="solution" style={iconStyle} />
    //     <div style={textStyle}>+10 Topics & Explanations</div>
    //   </div>
    //   <div style={column}>
    //     <Icon type="layout" style={iconStyle} />
    //     <div style={textStyle}>Revamped Interface</div>
    //   </div>
    // </div>

    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px", marginBottom: "10px" }}>
      <div>
        <Icon type="customer-service" style={iconStyle} />
        <div style={textStyle}>Built-in P2P Network</div>
      </div>
      <div>
        <Icon type="solution" style={iconStyle} />
        <div style={textStyle}>15+ New Topics & Explanations</div>
      </div>
      <div>
        <Icon type="layout" style={iconStyle} />
        <div style={textStyle}>Revamped Interface</div>
      </div>
      <div>
        <Icon type="code-o" style={iconStyle} />
        <div style={textStyle}>Source Code</div>
      </div>
    </div>
  );
};

export default WhatsNew;


// WEBPACK FOOTER //
// ./src/steps/whats-new/step.js